import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, bindResource, rpcCrudService } from "kea-resource";
import { CampoRepetidoIdentificacion, ResourceIdentificacionRepetido } from "./identificacion";

const controller = rpcController("CatalogosSat");

const otros = cacheResource({

    /**
     * Obtiene un itemCatalogoSat de clave de producto según la clave
     * @param clave clave del itemCatalogo
     */
    GetProducto: async (id: number): Promise<models.ProductoSAT> => await controller("GetProducto", { id: id }),
    /**
         * Busca un itemCatalogoSat de clave de producto dado una busqueda por texto
         * @param buscar 
         */
    ClaveProductosSat: async (buscar: string): Promise<models.ProductoSAT[]> => await controller("ClaveProductosSat", { buscar: buscar }),

    /**
     * Obtiene un itemcatalogo de UsoCFDI
     * @param clave Id del itemcatalogo
     */
    GetUsoCfdi: async (clave: string): Promise<models.ItemCatalogoSat> => await controller("GetUsoCfdi", { clave: clave }),

    /**
         * Busca un itemCatalogoSat de clave de UsoCFDI según la busqueda por texto
         * @param buscar 
         */
    ClaveUsoCfdiSat: async (buscar: string): Promise<models.ItemCatalogoSat[]> => await controller("ClaveUsoCfdiSat", { buscar: buscar }),

    /**
     * Obtiene un itemcatalogo de RegimenFiscal
     * @param clave Id del itemcatalogo
     */
    GetRegimenFiscal: async (clave: string): Promise<models.ItemCatalogoSat> => await controller("GetRegimenFiscal", { clave: clave }),

    /**
        * Busca un itemCatalogoSat de clave de RegimenFiscal según la busqueda por texto
        * @param buscar 
        */
    ClaveRegimenFiscalSat: async (buscar: string): Promise<models.ItemCatalogoSat[]> => await controller("ClaveRegimenFiscalSat", { buscar: buscar }),

    /**
     * Obtiene un itemcatalogo de ConsultarMonedas
     * @param clave Id del itemcatalogo
     */
    GetMoneda: async (clave: string): Promise<models.ItemCatalogoSat> => await controller("GetMoneda", { clave: clave }),

    /**
         * Busca un itemCatalogoSat de clave de ConsultarMonedas según la busqueda por texto
         * @param buscar 
         */
    ClaveMonedaSat: async (buscar: string): Promise<models.ItemCatalogoSat[]> => await controller("ClaveMonedaSat", { buscar: buscar }),

    /**
     * Obtiene un itemcatalogo de ConsultarMetodoPago
     * @param clave Id del itemcatalogo
     */
    GetMetodoPago: async (id: number): Promise<models.MetodoPagoSAT> => await controller("GetMetodoPago", { id: id }),


    /**
        * Busca un itemCatalogoSat de clave de ConsultarMetodoPago según la busqueda por texto
        * @param buscar 
        */
    ClaveMetodoPagoSat: async (buscar: string): Promise<models.MetodoPagoSAT[]> => await controller("ClaveMetodoPagoSat", { buscar: buscar }),

    /**
     * Obtiene un itemcatalogo de ConsultarFormaPago
     * @param clave Id del itemcatalogo
     */
    GetFormaPago: async (id: number): Promise<models.FormaPagoSAT> => await controller("GetFormaPago", { id: id }),


    /**
       * Busca un itemCatalogoSat de clave de ConsultarFormaPago según la busqueda por texto
       * @param buscar 
       */
    ClaveFormaPagoSat: async (buscar: string): Promise<models.FormaPagoSAT[]> => await controller("ClaveFormaPagoSat", { buscar: buscar }),

    /**
          * Obtiene una UnidadSAT según el id
          * @param id Id de la entidad
          */
    GetUnidad: async (id: number): Promise<models.UnidadSAT> => await controller("GetUnidad", { id: id }),

    /**Obtiene todas las UnidadesSAT */
    ClaveUnidadSat: async (buscar: string): Promise<models.UnidadSAT[]> => await controller("ClaveUnidadSat", { buscar: buscar }),

    GetPaisSat: async (id: number): Promise<models.PaisSAT> => await controller("GetPaisSat", { id: id }),

    ClavePaisSat: async (buscar: string): Promise<models.PaisSAT[]> => await controller("ClavePaisSat", { buscar: buscar }),

    CpSatSubTipoRem: async (): Promise<models.CpSatSubTipoRem[]> => await controller("CpSatSubTipoRemQuery", {}),

    CpSatClaveProd: async (): Promise<models.CpSatClaveProd[]> => await controller("CpSatClaveProdQuery", {}),

    CpSatTipoEmbalajeQuery: async (): Promise<models.CpSatTipoEmbalaje[]> => await controller("CpSatTipoEmbalajeQuery", {}),

    CpSatConfigAutotransporteQuery: async (): Promise<models.CpSatConfigAutotransporte[]> => await controller("CpSatConfigAutotransporteQuery", {}),


    GetCpSatConfigAutotransporte: async (id:number): Promise<models.CpSatConfigAutotransporte> => await controller("GetCpSatConfigAutotransporte",{ id: id }),


    CpSatTipoPermisoQuery: async (): Promise<models.CpSatTipoPermiso[]> => await controller("CpSatTipoPermisoQuery", {}),


    CpSatMunicipioQuery: async (): Promise<models.CpSatMunicipio[]> => await controller("CpSatMunicipioQuery", {}),
    CpSatLocalidadQuery: async (): Promise<models.CpSatLocalidad[]> => await controller("CpSatLocalidadQuery", {}),
    CpSatColoniaQuery: async (): Promise<models.CpSatColonia[]> => await controller("CpSatColoniaQuery", {}),
    CpSatEstadoQuery: async (): Promise<models.CpSatEstado[]> => await controller("CpSatEstadoQuery", {}),

    CpSatLocalidadByClaveMunicipioQuery: async (idMunicipio:number): Promise<models.CpSatLocalidad[]> => 
    await controller("CpSatLocalidadByClaveMunicipioQuery",{ idMunicipio }),
    
    
    CpSatColoniaByClaveMunicipioQuery: async (idMunicipio:number): Promise<models.CpSatColonia[]> => 
    await controller("CpSatColoniaByClaveMunicipioQuery",{ idMunicipio }),

    /*
    CpSatLocalidadByClaveEstadoQuery
    CpSatColoniaByClaveEstadoQuery
    */

}, {
        ClaveProductosSat: true,
        ClaveUsoCfdiSat: true,
        ClaveRegimenFiscalSat: true,
        ClaveFormaPagoSat: true,
        ClaveMetodoPagoSat: true,
        ClaveMonedaSat: true,
        CpSatSubTipoRem:true,
        CpSatClaveProd:true,
        CpSatTipoEmbalajeQuery:true,
        CpSatConfigAutotransporteQuery:true,
        CpSatTipoPermisoQuery:true,
    },
    {
    }
);


export const CatalogosSAT = bindResource({ ...otros });


// WEBPACK FOOTER //
// ./app/resources/items/catalogossat.tsx